import React, { useState, useEffect } from 'react';
import { Wrapper, Video } from './style';

const WebsiteVideo = ({ isActive, poster, video }) => {
  const [videoEl, setVideoEl] = useState();
  const paddingBottom = poster
    ? (poster.file.details.image.height / poster.file.details.image.width) * 100
    : (674 / 1220) * 100;

  useEffect(() => {
    if (!videoEl) return;
    if (isActive) {
      videoEl.play();
    } else {
      videoEl.pause();
    }
  }, [isActive]);

  return (
    <Wrapper style={{ paddingBottom: `${paddingBottom}%` }}>
      {video ? (
        <Video
          loop
          playsInline
          onClick={() => {
            if (videoEl.paused) {
              videoEl.play();
            } else {
              videoEl.pause();
            }
          }}
          poster={poster ? poster.file.url : null}
          src={video}
          ref={el => {
            if (el && !videoEl) {
              setVideoEl(el);
            }
          }}
        />
      ) : null}
    </Wrapper>
  );
};

export default React.memo(WebsiteVideo);
